import { ApplicationRef, ComponentFactoryResolver, EmbeddedViewRef, Injectable, Injector } from '@angular/core';
import { AlertComponent } from './alert/alert.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { MultipleButtonComponent } from './multiple-button/multiple-button.component';

@Injectable()
export class DialogService {
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
  ) {}

  confirm() {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(ConfirmComponent);
    const componentRef = componentFactory.create(this.injector);
    this.appRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);

    const { instance } = componentRef;
    instance.componentRef = componentRef;
    return instance;
  }

  alert() {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(AlertComponent);
    const componentRef = componentFactory.create(this.injector);
    this.appRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);

    const { instance } = componentRef;
    instance.componentRef = componentRef;
    return instance;
  }

  multipleButton() {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(MultipleButtonComponent);
    const componentRef = componentFactory.create(this.injector);
    this.appRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);

    const { instance } = componentRef;
    instance.componentRef = componentRef;
    return instance;
  }
}
